import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M11 5.25331L5.65079 4.0646C3.77725 3.64826 2 5.07392 2 6.99316V16.8956C2 18.3017 2.9766 19.5191 4.34921 19.8241L11 21.3021V5.25331Z\" fill=\"currentColor\"></path><path d=\"M13 21.3021L19.6508 19.8241C21.0234 19.5191 22 18.3017 22 16.8956V6.99316C22 5.07392 20.2227 3.64826 18.3492 4.0646L13 5.25331V21.3021Z\" fill=\"currentColor\"></path><defs><linearGradient id=\"paint0_linear_3364_4566\" x1=\"12\" y1=\"3.99194\" x2=\"12\" y2=\"21.3021\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"currentColor\"></stop><stop offset=\"1\" stop-color=\"currentColor\"></stop></linearGradient><linearGradient id=\"paint1_linear_3364_4566\" x1=\"12\" y1=\"3.99194\" x2=\"12\" y2=\"21.3021\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"currentColor\"></stop><stop offset=\"1\" stop-color=\"currentColor\"></stop></linearGradient></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }